import React, { useEffect, useState } from 'react'
import { postAgregarSuministro, postTablaInsumosMateralesPaquetes } from '../../../services/PaginaRuta'
import ModalAgregarPaqueteNoventaCuatro from './ModalAgregarPaqueteNoventaCuatro'
import ModalNoExistePaqueteGenericoMaestro from './ModalNoExistePaqueteGenericoMaestro';

const ModalSuministrosConfirmarCantidad = ({setmodalOnSuministrosConfirmarCantidad,item, idCirugia,passINfodata}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));  
  const[errorSeleccionarCantidad, seterrorSeleccionarCantidad]=useState('')
    const[modalOnAgregarPaqueteNoventaCuatro, setmodalOnAgregarPaqueteNoventaCuatro]=useState(false)
    const[passDataCerrarModal, setpassDataCerrarModal]=useState([])
    const [isPaqueteGenericoMaestro, setisPaqueteGenericoMaestro]=useState(false)
    const [messagePaqueteGenericoMaestro, setmessagePaqueteGenericoMaestro]=useState('')

    const handleCancelClick=()=>{
        setmodalOnSuministrosConfirmarCantidad(false)
    }

    const passDataCerrarModalSuministro=(data)=>{
      setpassDataCerrarModal(data)
      passINfodata(data)
      setmodalOnSuministrosConfirmarCantidad(false)
    }

    const handleOnsubmitGuardarSuministroYAbrirPaquete=(e)=>{
      e.preventDefault();
      //clinica cartagena
    // const paqueteGenericoCodigo = '39'
    

    //produccion pruebas 
    //  const paqueteGenericoCodigo = '94'

    //clinica estancia
    // const paqueteGenericoCodigo = 'GER'

    //variable de entorno
    //const paqueteGenericoCodigo = process.env.REACT_APP_PAQUETE_GENERICO_ID
    
      const bodyPaquete={
        MSRESO: item.MSRESO,
        //PaqCod: paqueteGenericoCodigo,
        ProCirCod: idCirugia,
        ProMCDpto: usuarioInfo.Sede,
        ProEmpCod:  usuarioInfo.Empresa,
        PQCaSuDs: ".0000",
        PQCaSuSl: `${e.target.cantidadSuministro.value}.0000`,
        PQCaSuPe: `${e.target.cantidadSuministro.value}.0000`,
        PQEdoIte: "S",
        PQEstDes: "N",
        PQEdoCaI: "N",
      }
    //console.log(bodyPaquete,'bodyPaquetebodyPaquete')
    
    if(errorSeleccionarCantidad==''){
      postAgregarSuministro(bodyPaquete).then((res)=>{
        console.log(res,'guardar suministro')       
        if(res.data.existePaqueteGenericoMaestro){
          if(!(res.data.existePaqueteGenerico)){
            //console.log(buscarUnPaquete,'encontrar 94')
            setmodalOnAgregarPaqueteNoventaCuatro(true)
          }else{
            setmodalOnSuministrosConfirmarCantidad(false)
            passINfodata(bodyPaquete)
          }
        }else{
          setisPaqueteGenericoMaestro(true)
          setmessagePaqueteGenericoMaestro(res.data.message)
        }
        
      }) 
      
    }

    }

    useEffect(()=>{
      seterrorSeleccionarCantidad('Ingresar una cantidad')      
    },[])

    const handleOnchange=(e)=>{
      if(e.target.value){
        seterrorSeleccionarCantidad('')
      }else{
        seterrorSeleccionarCantidad('Ingresar una cantidad')
      }
      

    }

  return (
    <>
    <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%-3rem)]  my-6 mx-auto relative w-auto pointer-events-none pt-6">
          <div className=" overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
            <div className="flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Suministros y paquetes 
              </h5>
              <button
                type="button"
                onClick={handleCancelClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <form onSubmit={handleOnsubmitGuardarSuministroYAbrirPaquete}>
              <div className="flex-auto overflow-y-auto relative p-4">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/4  px-4 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                     Suministro
                    </label>
                    <input
                    defaultValue={item.MSRESO}
                    disabled={true}
                    
                      type="text"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-2/4  px-4 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Descripción
                    </label>
                    <input
                    defaultValue={item.MSNomG}
                      type="text"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-4 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Cantidad
                    </label>
                    <input
                      onChange={handleOnchange}
                      name='cantidadSuministro'
                      autoComplete='off'
                      type="number"
                      className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorSeleccionarCantidad}
                    </label>
                  </div>
                  
                </div>
              </div>
              
           
            
            
            
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button type="button"
              onClick={handleCancelClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal">
              Cancelar
              </button>
              <button
                type="submit"
                //onClick={handleClickDataCirugia}
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Guardar
              </button>
            </div>
            </form>
          </div>
        </div>
      </div>
      {modalOnAgregarPaqueteNoventaCuatro? <ModalAgregarPaqueteNoventaCuatro setmodalOnAgregarPaqueteNoventaCuatro={setmodalOnAgregarPaqueteNoventaCuatro} idCirugia={idCirugia} passDataCerrarModalSuministro={passDataCerrarModalSuministro}/>:null}
      {isPaqueteGenericoMaestro? <ModalNoExistePaqueteGenericoMaestro setisPaqueteGenericoMaestro={setisPaqueteGenericoMaestro} messagePaqueteGenericoMaestro={messagePaqueteGenericoMaestro}/>:null}
    </>
  )
}

export default ModalSuministrosConfirmarCantidad